module.exports = __webpack_public_path__ + "static/media/4ODA11.92791e4a.jpg";